export const date_presets = [
  {
    label: "-1 anne",
    range: [
      new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString("en-CA"),
      new Date().toLocaleDateString("en-CA"), //start date today. YYYY-MM-DD
    ],
  },
  {
    label: "-6 mois",
    range: [
      new Date(new Date().setMonth(new Date().getMonth() - 6)).toLocaleDateString("en-CA"),
      new Date().toLocaleDateString("en-CA"), //start date today. YYYY-MM-DD
    ],
  },
  {
    label: "-3 mois",
    range: [
      new Date(new Date().setMonth(new Date().getMonth() - 3)).toLocaleDateString("en-CA"),
      new Date().toLocaleDateString("en-CA"), //start date today. YYYY-MM-DD
    ],
  },
  {
    label: "Aujourd'hui",
    range: [new Date().toLocaleDateString("en-CA"), new Date().toLocaleDateString("en-CA")],
  },
  {
    label: "+3 mois",
    range: [
      new Date().toLocaleDateString("en-CA"),
      new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString("en-CA"),
    ],
  },
  {
    label: "+6 mois",
    range: [
      new Date().toLocaleDateString("en-CA"),
      new Date(new Date().setMonth(new Date().getMonth() + 6)).toLocaleDateString("en-CA"),
    ],
  },
  {
    label: "+1 anne",
    range: [
      new Date().toLocaleDateString("en-CA"),
      new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toLocaleDateString("en-CA"),
    ],
  },
]

export const stripTags = (input) => {
  return input.replace(/<\/?[^>]+(>|$)/g, "")
}

export const getCourseTypeColor = (type) => {
  const colors = {
    fr: "blue lighten-1",
    frdistance: "cyan lighten-1",
    re: "amber lighten-1",
    it: "teal lighten-1",
    cp: "pink lighten-2",
  }
  return colors[type] || "grey"
}

export const getCourseTypeLabel = (type) => {
  const types = {
    fr: "Français",
    re: "Recherche emploi",
    frdistance: "Français distance",
    it: "Informatique",
    cp: "Cours privé",
  }
  return types[type] || ""
}

export const getCourseTypeAbbr = (type) => {
  if (type === "frdistance") return "FR"
  return type ? type.toUpperCase() : ""
}

export const getHashColor = (name) => {
  const colors = [
    "#AD1457", // pink darken-3
    "#6A1B9A", // purple darken-3
    "#4527A0", // deep-purple darken-3
    "#283593", // indigo darken-3
    "#1565C0", // blue darken-3
    "#00838F", // cyan darken-3
    "#00695C", // teal darken-3
    "#2E7D32", // green darken-3
    "#558B2F", // light-green darken-3
    "#EF6C00", // orange darken-3
    "#BF360C", // deep-orange darken-4
    "#4E342E", // brown darken-3
    "#37474F", // blue-grey darken-3
    "#C62828", // red darken-3
    "#0277BD", // light-blue darken-3
    "#7B1FA2", // purple darken-2
    "#303F9F", // indigo darken-2
    "#1B5E20", // green darken-4
    "#E65100", // orange darken-4
    "#3E2723", // brown darken-4
  ]
  if (!name) return colors[0]
  let hash = 0
  const normalized = name.trim().toLowerCase()
  for (let i = 0; i < normalized.length; i++) {
    hash = ((hash << 5) - hash + normalized.charCodeAt(i)) | 0
  }
  return colors[Math.abs(hash) % colors.length]
}

export const getCourseVariants = (type) => {
  switch (type) {
    case "fr":
    case "cp":
      return [
        "Alphabétisation",
        "A0",
        "A0.1",
        "A0.2",
        "A1",
        "A1.1",
        "A1.2",
        "A2",
        "A2.1",
        "A2.2",
        "B1",
        "B1.1",
        "B1.2",
        "B2",
        "B2.1",
        "B2.2",
        "C1",
        "C1.1",
        "C1.2",
        "C2",
        "C2.1",
        "C2.2",
      ]
    case "frdistance":
    case "re":
      return [
        "A0",
        "A0.1",
        "A0.2",
        "A1",
        "A1.1",
        "A1.2",
        "A2",
        "A2.1",
        "A2.2",
        "B1",
        "B1.1",
        "B1.2",
        "B2",
        "B2.1",
        "B2.2",
        "C1",
        "C1.1",
        "C1.2",
        "C2",
        "C2.1",
        "C2.2",
      ]
    case "it":
      return ["Débutant", "Intermédiaire", "Avancé"]
    default:
      return []
  }
}
